module.exports = __webpack_public_path__ + "static/img/atlas1.c1957a45.jpg";